module.exports = __webpack_public_path__ + "static/media/true-digital-thickness.dd76a921.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueDigital/true-digital-thickness.png
// module id = 3578
// module chunks = 0